export type LoginSubmitDetail = {
  email: string
  password: string
  rememberMe: boolean
}

export class LoginSubmitEvent extends Event {
  static type = 'csc-login-submit' as const
  detail: LoginSubmitDetail

  constructor(detail: LoginSubmitDetail) {
    super(LoginSubmitEvent.type, { bubbles: true, composed: true })
    this.detail = detail
  }
}

export type LoginVerifyDetail = {
  code: string
}

export class LoginVerifyEvent extends Event {
  static type = 'csc-login-verify' as const
  detail: LoginVerifyDetail

  constructor(detail: LoginVerifyDetail) {
    super(LoginVerifyEvent.type, { bubbles: true, composed: true })
    this.detail = detail
  }
}

export type LoginSuccessDetail = {
  email?: string
  rememberMe?: boolean
  data: unknown
}

export class LoginSuccessEvent extends Event {
  static type = 'csc-login-success' as const
  detail: LoginSuccessDetail

  constructor(detail: LoginSuccessDetail) {
    super(LoginSuccessEvent.type, { bubbles: true, composed: true })
    this.detail = detail
  }
}

export type LoginPasswordExpiredDetail = {
  /** Change password page returned by the API. */
  returnUrl: string
  data: unknown
}

export class LoginPasswordExpiredEvent extends Event {
  static type = 'csc-login-password-expired' as const
  detail: LoginPasswordExpiredDetail

  constructor(detail: LoginPasswordExpiredDetail) {
    super(LoginPasswordExpiredEvent.type, { bubbles: true, composed: true })
    this.detail = detail
  }
}

export class LoginResendEvent extends Event {
  static type = 'csc-login-resend' as const

  constructor() {
    super(LoginResendEvent.type, { bubbles: true, composed: true })
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [LoginSubmitEvent.type]: LoginSubmitEvent
    [LoginVerifyEvent.type]: LoginVerifyEvent
    [LoginSuccessEvent.type]: LoginSuccessEvent
    [LoginResendEvent.type]: LoginResendEvent
    [LoginPasswordExpiredEvent.type]: LoginPasswordExpiredEvent
  }
}
